export class ContentSignUp {
  id: any;
  label: any;
  signupLabel: any;
  signupLink: any;
  signupNewWindow: any;
  signupTooltipLabel: any;
  hideloginSignupTooltip: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['rightnavLabel']) {
        this.signupLabel = contentjson['rightnavLabel'];
      }
      if (contentjson['rightnavLink']) {
        this.signupLink = contentjson['rightnavLink'];
      }
      if (contentjson['rightnavopeninnewTab']) {
        this.signupNewWindow = contentjson['rightnavopeninnewTab'];
      }
      if (contentjson['signupTooltipLabel']) {
        this.signupTooltipLabel = contentjson['signupTooltipLabel'];
      }
      if (contentjson['hideloginSignupTooltip']) {
        this.hideloginSignupTooltip = contentjson['hideloginSignupTooltip'];
      }
    }
  }
}
